import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FULL_DAY_OUTPUT_FORMAT } from 'bento-ordering/base/constants/timeFormat';
import { getFormattedDayOfWeek } from 'bento-ordering/base/utils/dates';
import { getTimeFromDateTime } from 'bento-ordering/base/utils/getTime';
import { selectLogoDestinationUrl } from 'bento-ordering/locations/selectors/selectLogoDestinationUrl';
import { selectFirstRestaurantLocationError } from 'bento-ordering/locations/selectors/selectFirstRestaurantLocationError';
import LocationOffline from 'components/Location/LocationOffline';

function AsapNotCurrentlyAvailableOffline() {
  const error = useSelector(selectFirstRestaurantLocationError);
  const logoDestinationUrl = useSelector(selectLogoDestinationUrl);
  const title = 'Online ordering is not currently accepting orders';
  const nextAvailableAsapDateTime =
    error?.response?.next_available_asap_datetime;

  const description = `Our next ordering hours start ${getTimeFromDateTime(
    nextAvailableAsapDateTime
  )} ${getFormattedDayOfWeek(
    nextAvailableAsapDateTime,
    FULL_DAY_OUTPUT_FORMAT
  )}.`;

  return nextAvailableAsapDateTime ? (
    <LocationOffline
      logoDestinationUrl={logoDestinationUrl}
      title={title}
      description={description}
    />
  ) : (
    <Redirect to="/online-ordering" />
  );
}

export default AsapNotCurrentlyAvailableOffline;
